export default __webpack_public_path__ + "how-to-set-up-shake-sdk.jpg";